import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import clsx from "clsx";
import React, { useState } from "react";
import CustomPriceSpan from "../../../../../components/CustomPriceSpan";
import _ from "lodash";
import Helper from "../../../../../utils/Helper";
import * as setOffSelectors from "../../../../../selectors/set-off";
import EmptyItemView from "../../../../../components/EmptyItemView";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import constants from "../../../../../constants";
import Constants from "../../../../../constants";
function ConfirmationSetOffModal({
  handleShow,
  show,
  handleClose,
  data,
  partAmt,
  handleSubmit,
  loading,
  type,
  selectedCurrency,
}) {
  const setOffData = _.get(data, ["data"], []);
  const newSetOffData = _.map(setOffData, (setOff, index) => {
    if (
      _.get(partAmt, [index, "total"], 0) === 0 ||
      _.get(partAmt, [index, "total"], 0) === "0.00"
    ) {
      return null;
    }
    return setOff;
  });
  const getDebitAmount = () => {
    const debit = _.map(partAmt, (item, index) => {
      if (item.negative) {
        return _.floor(item.total, 2);
      }
    });
    return _.isNaN(_.sum(debit)) || _.isUndefined(_.sum(debit))
      ? 0
      : _.sum(debit);
  };

  const getCreditAmount = () => {
    const credit = _.map(partAmt, (item, index) => {
      if (!item.negative) {
        return _.floor(item.total, 2);
      }
    });
    return _.isNaN(_.compact(credit)) || _.isUndefined(_.compact(credit))
      ? 0
      : _.sum(_.compact(credit));
  };

  const handleSetOffSubmit = () => {
    let totalWithdraw = 0;

    const formattedSetOffSubmitData = _.map(setOffData, (setOff, index) => {
      if (_.get(partAmt, [index, "total"], 0) == 0) {
        return null;
      }
      const total = _.get(partAmt, [index, "total"], 0);
      const negative = _.get(partAmt, [index, "negative"], false);
      const contractRef = setOffSelectors.getSetOffContractReference(setOff);

      totalWithdraw += negative ? -total : total;

      return {
        contract_reference: contractRef,
        amount: `${negative ? "-" : ""}${total}`,
      };
    });

    handleSubmit &&
      handleSubmit(_.compact(formattedSetOffSubmitData), totalWithdraw);
  };

  const modalTitle = () => {
    switch (type) {
      case constants.SET_OFF_TYPE:
        return "e-Setoff";
        break;
      case constants.PAYMENT_TYPE:
        return "e-Payment";
        break;
      case constants.WITHDRAWAL_TYPE:
        return "e-Withdrawal";
        break;
    }
  };

  const contentTitle = () => {
    switch (type) {
      case constants.SET_OFF_TYPE:
        return "setoff";
        break;
      case constants.PAYMENT_TYPE:
        return "payment";
        break;
      case constants.WITHDRAWAL_TYPE:
        return "withdraw";
        break;
    }
  };

  const modalContentAmountText = () => {
    switch (type) {
      case constants.SET_OFF_TYPE:
        return "Debit Amount";
        break;
      case constants.PAYMENT_TYPE:
        return "Payment Amount";
        break;
      case constants.WITHDRAWAL_TYPE:
        return "Withdrawal Amount";
        break;
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered className="modal-w-900">
      <Modal.Header closeButton>
        <Modal.Title className={"annoucement-modal-title"}>
          {modalTitle()}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="font-medium">
          Are you sure you want to{" "}
          <span style={{ textTransform: "lowerCase" }}>{contentTitle()}</span> the
          amount?
        </p>
        <div className={"responsive-table-border"}>
          <Table responsive="lg">
            <thead>
              <tr className={"custom-table-setoff-styled"}>
                <th style={{ width: 100 }}>Date</th>
                <th style={{ width: 120 }}>Reference No</th>
                <th style={{ width: 100 }}>Stock Code</th>
                <th style={{ width: 120 }}>Stock Name</th>
                {type !== constants.WITHDRAWAL_TYPE ? (
                  <>
                    <th style={{ width: 100 }}>Amount</th>
                    <th style={{ width: 100 }}>Accrue Interest</th>
                  </>
                ) : (
                  false
                )}
                <th style={{ width: 100 }}>Total Amount</th>

                <th style={{ width: 100 }}>Balance Amount</th>

                {/*===== End for For "CheckBox" ===== */}
                {/*===== For "Part Amt" ===== */}
                <th style={{ width: "200px" }}>Selected Amount</th>
                {/*===== End for "Part Amt" ===== */}
              </tr>
            </thead>
            <tbody>
              {!_.isEmpty(newSetOffData) ? (
                _.map(newSetOffData, (setOff, index) => {
                  const refNo =
                    setOffSelectors.getSetOffContractReference(setOff);
                  const date = setOffSelectors.getSetOffTransactionDate(setOff);
                  const stockCode = setOffSelectors.getSetOffStockCode(setOff);
                  const stockName = setOffSelectors.getSetOffStockName(setOff);
                  const balAmount =
                    setOffSelectors.getSetOffOutstandingAmountFullText(setOff);
                  const accrueInterest =
                    setOffSelectors.getSetOffAccrueInterestFullText(setOff);
                  const total =
                    setOffSelectors.getSetOffTotalOutstandingBalance(setOff);
                  const totalFullText =
                    setOffSelectors.getSetOffTotalOutstandingBalanceFullText(
                      setOff,
                    );
                  const currencyCode =
                    setOffSelectors.getSetOffCurrencyCode(setOff);
                  const totalOutstandingAmount =
                    setOffSelectors.getSetOffTotalOutstandingAmountFullText(
                      setOff,
                    );
                  if (_.isEmpty(setOff)) {
                    return false;
                  }
                  return (
                    <tr key={index}>
                      <td>{date}</td>
                      <td>{refNo}</td>
                      <td>{stockCode ?? "-"}</td>
                      <td>{stockName ?? "-"}</td>
                      {type !== constants.WITHDRAWAL_TYPE ? (
                        <>
                          <td>{balAmount}</td>
                          <td>{accrueInterest}</td>
                        </>
                      ) : (
                        false
                      )}
                      <td>{totalOutstandingAmount}</td>
                      <td>{totalFullText}</td>
                      <td>
                        <span>
                          {currencyCode}{" "}
                          {_.get(partAmt, [index, "negative"], false)
                            ? "-"
                            : "+"}{" "}
                          <CustomPriceSpan
                            value={_.toNumber(
                              _.get(partAmt, [index, "total"], 0),
                            )}
                          />
                        </span>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={type !== Constants.WITHDRAWAL_TYPE ? 8 : 6}>
                    <EmptyItemView />
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot className="setoff-table-footer">
              {type !== constants.WITHDRAWAL_TYPE && (
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    {type !== constants.WITHDRAWAL_TYPE ? (
                        <>
                          <th></th>
                          <th></th>
                        </>
                    ) : (
                        false
                    )}
                    <th></th>
                    <th>Credit Amount</th>
                    <th>
                      <div className="d-flex justify-content-between">
                      <span>
                        {selectedCurrency?.text}{" "}
                        <CustomPriceSpan
                            value={getCreditAmount()}
                        ></CustomPriceSpan>
                      </span>
                      </div>
                    </th>
                  </tr>
              )}
              <tr>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                {type !== constants.WITHDRAWAL_TYPE ? (
                  <>
                    <th></th>
                    <th></th>
                  </>
                ) : (
                  false
                )}
                <th></th>
                <th>{modalContentAmountText()}</th>
                <th>
                  <div className="d-flex justify-content-between">
                    <span>
                      {" "}
                      {selectedCurrency?.text}{" "}
                      <CustomPriceSpan
                        value={getDebitAmount()}
                      ></CustomPriceSpan>
                    </span>
                  </div>
                </th>
              </tr>
              {type !== constants.WITHDRAWAL_TYPE && (
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th colSpan={2}>
                    <div
                      className={clsx("d-flex justify-content-between", {
                        ["positive-number"]: _.isEqual(
                          Helper.formattedPrice(getDebitAmount()),
                          Helper.formattedPrice(getCreditAmount()),
                        ),
                        ["negative-number"]: !_.isEqual(
                          Helper.formattedPrice(getDebitAmount()),
                          Helper.formattedPrice(getCreditAmount()),
                        ),
                      })}
                    >
                      {_.isEqual(
                        Helper.formattedPrice(getDebitAmount()),
                        Helper.formattedPrice(getCreditAmount()),
                      )
                        ? "The enter amount is valid"
                        : "Amount doesn't tally"}
                    </div>
                  </th>
                </tr>
              )}
            </tfoot>
          </Table>
        </div>
        <div className="d-flex justify-content-end my-3 mr-3">
          <button
            className={clsx("btn custom-button-back")}
            onClick={(e) => {
              e.preventDefault();
              handleClose();
            }}
          >
            Cancel
          </button>
          <button
            className={clsx("btn custom-button-primary")}
            type="submit"
            style={{ backgroundColor: "#9D7905" }}
            onClick={handleSetOffSubmit}
          >
            Confirm
          </button>
        </div>
        <LoadingOverlay loading={loading}></LoadingOverlay>
      </Modal.Body>
    </Modal>
  );
}

export default ConfirmationSetOffModal;
